import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'
import { expirationDelta } from '@/utils/string'

interface Props {
  row: QuoteSummary
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteSummaryExpiration',
  props: {
    row: null
  },
  setup(__props: any) {

const props = __props as {
  row: QuoteSummary
};



const isExpired = computed(() => {
  const isPastExpiration = props.row.expirationDatetime && isExpiredV2(props.row.expirationDatetime)
  const isPickupInPast = props.row.pickupDatetime && new Date(props.row.pickupDatetime) < new Date()
  return isPickupInPast || isPastExpiration
})

const expirationText = computed(() => {
  if (isExpired.value) {
    return 'Expired'
  }
  if (!props.row.expirationDatetime) {
    return ''
  }
  return expirationDelta(props.row.expirationDatetime)
})

const isExpiringWithin24Hours = computed(() => {
  if (!props.row.expirationDatetime) {
    return false
  }
  const hoursDiff = (new Date(props.row.expirationDatetime).getTime() - Date.now()) / (1000 * 60 * 60)
  return hoursDiff < 24 && hoursDiff > 0
})


return { __sfc: true,props, isExpired, expirationText, isExpiringWithin24Hours }
}

})